type Props = {};

export const CreateFlowIcon = (props: Props) => {
  return (
    <svg fill="none" height="56" viewBox="0 0 57 56" width="57" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#DCFFEF" height="56" rx="28" width="56" x="0.333496" />
      <mask
        height="32"
        id="mask0_6484_3379"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="33"
        x="12"
        y="12"
      >
        <rect fill="#D9D9D9" height="32" width="32" x="12.3335" y="12" />
      </mask>
      <g mask="url(#mask0_6484_3379)">
        <path
          d="M32.3333 37.3333V36H29.6667C28.9333 36 28.3056 35.7389 27.7833 35.2167C27.2611 34.6944 27 34.0667 27 33.3333V22.6667H24.3333V24C24.3333 24.7333 24.0722 25.3611 23.55 25.8833C23.0278 26.4056 22.4 26.6667 21.6667 26.6667H17.6667C16.9333 26.6667 16.3056 26.4056 15.7833 25.8833C15.2611 25.3611 15 24.7333 15 24V18.6667C15 17.9333 15.2611 17.3056 15.7833 16.7833C16.3056 16.2611 16.9333 16 17.6667 16H21.6667C22.4 16 23.0278 16.2611 23.55 16.7833C24.0722 17.3056 24.3333 17.9333 24.3333 18.6667V20H32.3333V18.6667C32.3333 17.9333 32.5944 17.3056 33.1167 16.7833C33.6389 16.2611 34.2667 16 35 16H39C39.7333 16 40.3611 16.2611 40.8833 16.7833C41.4056 17.3056 41.6667 17.9333 41.6667 18.6667V24C41.6667 24.7333 41.4056 25.3611 40.8833 25.8833C40.3611 26.4056 39.7333 26.6667 39 26.6667H35C34.2667 26.6667 33.6389 26.4056 33.1167 25.8833C32.5944 25.3611 32.3333 24.7333 32.3333 24V22.6667H29.6667V33.3333H32.3333V32C32.3333 31.2667 32.5944 30.6389 33.1167 30.1167C33.6389 29.5944 34.2667 29.3333 35 29.3333H39C39.7333 29.3333 40.3611 29.5944 40.8833 30.1167C41.4056 30.6389 41.6667 31.2667 41.6667 32V37.3333C41.6667 38.0667 41.4056 38.6944 40.8833 39.2167C40.3611 39.7389 39.7333 40 39 40H35C34.2667 40 33.6389 39.7389 33.1167 39.2167C32.5944 38.6944 32.3333 38.0667 32.3333 37.3333Z"
          fill="#139E60"
        />
      </g>
    </svg>
  );
};
